import { render, staticRenderFns } from "./DiscoveryExpertView.vue?vue&type=template&id=58a89eed&scoped=true"
import script from "./DiscoveryExpertView.vue?vue&type=script&lang=js"
export * from "./DiscoveryExpertView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a89eed",
  null
  
)

export default component.exports